module.exports = __webpack_public_path__ + "static/media/vashet.af63dd32.png";